import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Store } from 'store';
import getPrice from 'store/price/selector/getPrice';
import calculateDiscountPercent from 'utils/price/calculateDiscountPercent';
import OpLabel from '../op-ui-wrappers/OpLabel/OpLabel';
import styles from './PriceDiscountPercentage.module.scss';

export interface OwnProps {
  categoryId: number;
  productId: number;
  useMinimalQuantity?: boolean;
}

const PriceDiscountPercentage = ({ categoryId, productId, useMinimalQuantity }: OwnProps) => {
  const price = useSelector((store: Store) => getPrice(store, categoryId || 0, productId, 1, true, useMinimalQuantity));
  const { t } = useTranslation();

  if (!price) {
    return null;
  }

  const discountedPercent = calculateDiscountPercent(price.ip, price.ipi);
  if (discountedPercent === '0') {
    return null;
  }

  return (
    <OpLabel size="x-small" color="primary" className={styles.discountPercent}>
      {discountedPercent}% {t('txt_off')}
    </OpLabel>
  );
};

export default React.memo(PriceDiscountPercentage);
